"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A11ySettingsProvider = exports.A11ySettingsContext = void 0;
const react_1 = __importStar(require("react"));
const LwtApp_1 = require("../../../LwtApp");
const config_1 = __importDefault(require("../../../@internal/config"));
const { defaultA11ySettings } = config_1.default;
const isValid = (value, scaling, minVal, maxVal) => (value >= 0 && scaling + value <= maxVal) || (value < 0 && scaling + value >= minVal);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.A11ySettingsContext = react_1.default.createContext({});
const A11ySettingsProvider = props => {
    const [{ settings }, { saveSettingsApi }] = LwtApp_1.useLwtStore();
    const [state, setState] = react_1.useState(settings.accessibility);
    const onToggleChange = (key, name) => () => {
        var _a;
        const newValue = !state[key][name];
        const optimisticResult = Object.assign(Object.assign({}, state), { [key]: Object.assign(Object.assign({}, state[key]), { [name]: !state[key][name] }) });
        setState(optimisticResult);
        (_a = props === null || props === void 0 ? void 0 : props.onSettingChangeSubscription) === null || _a === void 0 ? void 0 : _a.call(props, name, newValue);
        return optimisticResult;
    };
    const onScalingChange = (key, name) => (value, minVal, maxVal) => {
        var _a;
        const scaling = state[key][name];
        if (isValid(value, scaling, minVal, maxVal)) {
            const newValue = scaling + value;
            const optimisticResult = Object.assign(Object.assign({}, state), { [key]: Object.assign(Object.assign({}, state[key]), { [name]: newValue }) });
            setState(optimisticResult);
            (_a = props === null || props === void 0 ? void 0 : props.onSettingChangeSubscription) === null || _a === void 0 ? void 0 : _a.call(props, name, newValue);
            return optimisticResult;
        }
        return state;
    };
    // accepting 'value' allows for optimistic state updates to be syncronous (i.e. not worrying about react hooks being async)
    const save = (value) => __awaiter(void 0, void 0, void 0, function* () {
        const data = value !== null && value !== void 0 ? value : state;
        return saveSettingsApi('accessibility', data);
    });
    const reset = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setState((_a = settings.accessibility) !== null && _a !== void 0 ? _a : defaultA11ySettings);
    });
    react_1.useEffect(() => {
        var _a;
        setState((_a = settings.accessibility) !== null && _a !== void 0 ? _a : defaultA11ySettings);
    }, [settings.accessibility]);
    return (react_1.default.createElement(exports.A11ySettingsContext.Provider, { value: [state, { onToggleChange, onScalingChange, save, reset }] }, props === null || props === void 0 ? void 0 : props.children));
};
exports.A11ySettingsProvider = A11ySettingsProvider;
